import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '@digital-hig/typography';
import Card, { CardDivider } from '@digital-hig/card';
/* eslint-disable import/no-extraneous-dependencies */
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { Box } from '@mui/material';

const ListingShimmer = ({ img = false }) => (
  <CardRootElement className="card-action">
    {img && (
      <Box className="default-card-image">
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
        />
      </Box>
    )}
    <CardContent>
      <Typography
        sx={{ mb: 3 }}
        variant="headline-small"
        className="card-heading"
      >
        <Skeleton animation="pulse" variant="text" />
      </Typography>

      <Skeleton animation="pulse" variant="text" />
    </CardContent>
    <CardDivider />
    <CardActions sx={{ mt: 6 }}>
      <Skeleton animation="pulse" variant="text" width="60px" />
    </CardActions>
  </CardRootElement>
);

const CardRootElement = styled(Card)`
  .card-action {
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.10) inset;

    & > div:active {
      background: #fff;
    }

    &:focus {
      & > div {
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset;
        background: #fff !important;
      }

      svg {
        svg {
          outline: none !important;
        }
      }
    }
  }

  .default-card-image {
    height: 205px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    box-sizing: border-box;

    img {
      height: 100% !important;
      object-fit: contain;
      width: 100%;
    }
  }

  .card-heading {
    height: 52px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 767px) {
      height: 46px;
    }
  }

  .card-desc {
    height: 48px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

/* eslint react/require-default-props: off */
ListingShimmer.propTypes = {
  img: PropTypes.bool,
};

export default ListingShimmer;
